import type { RouteRecordRaw } from "vue-router";
import { APP_CHAT_CUSTOMER_ROUTES } from "@/Generated/Routes/paths";

const CustomerRoutes: RouteRecordRaw[] = [
  {
    ...APP_CHAT_CUSTOMER_ROUTES.legalAgreements.root,
    component: () => import("@/Views/chat/customer/views/LegalAgreements/List.vue"),
    meta: {
      i18nTitle: "settings.customer.legal_agreements_title",
    },
  },
  {
    ...APP_CHAT_CUSTOMER_ROUTES.legalAgreements.view.root,
    component: () => import("@/Views/chat/customer/views/LegalAgreements/View.vue"),
    meta: {
      noHeader: true,
    },
  },
];

export default CustomerRoutes;
